import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { Users, Wallet, BarChart2, ChevronRight } from 'lucide-react';

const fmt = (n) => Number(n || 0).toLocaleString('th-TH');

export default function Manage() {
  const [stats, setStats] = useState({ debtors: 0, totalOwe: 0, myDebts: 0, totalMyDebt: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [d, m] = await Promise.all([api.get('/debtors'), api.get('/mydebt')]);
        setStats({
          debtors: d.data.length,
          totalOwe: d.data.reduce((s, x) => s + (x.totalDebt || 0), 0),
          activeDebtors: d.data.filter(x => (x.totalDebt || 0) > 0).length,
          myDebts: m.data.length,
          totalMyDebt: m.data.reduce((s, x) => s + (x.totalDebt || 0), 0),
          activeMyDebts: m.data.filter(x => (x.totalDebt || 0) > 0).length,
        });
      } catch { }
      setLoading(false);
    };
    load();
  }, []);

  const menus = [
    { to: '/debtors', icon: <Users size={22} />, label: 'ຈັດການລູກໜີ້', desc: `${stats.activeDebtors || 0} ລາຍທີ່ຄ້າງຊຳລະ`, color: 'from-dark to-dark/80' },
    { to: '/mydebt', icon: <Wallet size={22} />, label: 'ໜີ້ທີ່ຂ້ອຍຕິດ', desc: `${stats.activeMyDebts || 0} ລາຍທີ່ຍັງຄ້າງ`, color: 'from-red-800 to-red-900/80' },
    { to: '/history', icon: <BarChart2 size={22} />, label: 'ປະຫວັດທັງໝົດ', desc: 'ເບິ່ງແລະ Export PDF', color: 'from-muted to-muted/80' },
  ];

  return (
    <div className="space-y-4 animate-fade-in">
      <div className="pt-2">
        <h1 className="page-title">ແຜງຄວບຄຸມ</h1>
        <p className="text-muted text-sm">ພາບລວມລະບົບ</p>
      </div>

      {loading ? (
        <div className="flex justify-center pt-10">
          <div className="w-8 h-8 border-2 border-dark border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <>
          {/* Stats */}
          <div className="grid grid-cols-2 gap-3">
            <div className="card bg-gradient-to-br from-dark to-dark/80 border-0">
              <p className="text-cream/50 text-xs">ຮັບໄດ້ທັງໝົດ</p>
              <p className="text-sand font-bold text-xl mt-0.5">{fmt(stats.totalOwe)} KIP</p>
              <p className="text-cream/30 text-xs">{stats.debtors} ລາຍຊື່</p>
            </div>
            <div className="card bg-gradient-to-br from-red-900/80 to-red-800/60 border-red-700/30">
              <p className="text-red-200/50 text-xs">ຕ້ອງຈ່າຍທັງໝົດ</p>
              <p className="text-red-300 font-bold text-xl mt-0.5">{fmt(stats.totalMyDebt)} KIP</p>
              <p className="text-red-200/30 text-xs">{stats.myDebts} ລາຍຊື່</p>
            </div>
          </div>

          {/* Net */}
          <div className="card">
            <p className="text-muted text-xs mb-1">ຍອດສຸດທິ (ຮັບ - ຈ່າຍ)</p>
            <p className={`text-2xl font-bold ${(stats.totalOwe - stats.totalMyDebt) >= 0 ? 'text-green-600' : 'text-red-500'}`}>
              {fmt(stats.totalOwe - stats.totalMyDebt)} KIP
            </p>
          </div>

          {/* Menu */}
          <div className="space-y-2">
            {menus.map(item => (
              <Link key={item.to} to={item.to}
                className={`flex items-center gap-4 p-4 rounded-2xl bg-gradient-to-r ${item.color} shadow-sm active:scale-[0.98] transition-all`}>
                <span className="text-cream">{item.icon}</span>
                <div className="flex-1">
                  <p className="font-semibold text-cream text-sm">{item.label}</p>
                  <p className="text-cream/50 text-xs">{item.desc}</p>
                </div>
                <ChevronRight size={20} className="text-cream/40" />
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
